import React from 'react';

import { handleImagePath } from '@lucid/hooks';

import SEO from '../seo/seo';
import type { Lucid } from '../../types/types';

type LucidHeadProps = {
  data?: Lucid.Directus.Custom.DirectusData;
  pageContext: Lucid.Context.Keys & Partial<Lucid.Context.Pagination>;
  location?: Partial<Location>;
};

const LucidHead = ({ pageContext, location }: LucidHeadProps) => {
  const { page, metatags: contextMetatags, pageType, nid, shortCode, product } = pageContext;

  let schemaMarkup = '';
  const nodeMetatags = contextMetatags
    ? contextMetatags?.reduce((previous, current) => {
        if (current.key === 'og:image' && current.value) {
          return [
            ...previous,
            {
              ...current,
              value: handleImagePath({
                filename_disk: current.value,
              } as Lucid.Directus.Generated.Directus_Files),
            },
          ];
        }

        if (current.key === 'schema_markup') {
          schemaMarkup = current.value || '';

          return previous;
        }

        return [...previous, current];
      }, [] as Lucid.Context.Metatag[])
    : [];

  const titleMetatag = nodeMetatags.find(mt => mt.key === 'title')?.value;
  const paginationEntityMetatags =
    page && page > 1
      ? [
          {
            key: 'title',
            value: `Page ${page}${titleMetatag ? ` for ${titleMetatag}` : ''}`,
          },
          {
            key: 'robots',
            value: 'follow, noindex',
          },
        ]
      : undefined;

  const metatags = paginationEntityMetatags ?? nodeMetatags;

  const finalMetatags = pageContext.isScheduledRelease
    ? [
        ...(metatags || []).filter(m => m.key !== 'robots'),
        {
          key: 'robots',
          value: 'noindex, nofollow',
        },
      ]
    : metatags;

  return (
    <SEO
      key={`seo-${pageType}-${nid ?? '1'}`}
      location={location}
      metatags={finalMetatags || []}
      product={product}
      schemaMarkup={schemaMarkup}
      shortCode={shortCode}
    />
  );
};

export default LucidHead;
